// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** UPDATE VOTER ID START ************************/
export const voterIdUpdateDetails = (updateVoterIdData: any) => {
	const data = {
		VoterIdDetailsToken: updateVoterIdData,
	};
	const url = `${API_URL}updateVoterIdDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE VOTER ID END ************************/
